const theme = {
  primaryColor: "#000",
  secondaryColor: "#f9f9f9",
  thirdColor: "#909090"
};

export default theme;
